import { useDataLoader } from "2g-hooks/fetch";
import { useDidUpdateEffect } from "2g-hooks";

import { DATA } from "b2b/api/paths";

export default function useZadostiFixniNaroky({
  datumOd,
  datumDo,
  zakaznik,
  uzivatel,
  projekt,
  zdroj,
  produkt
}) {
  const canBeLoaded = Boolean(
    datumOd &&
      datumDo &&
      zakaznik &&
      uzivatel &&
      projekt &&
      zdroj?.nazevCs &&
      ["VZO", "MZO"].includes(zdroj?.nazevCs.toUpperCase()) &&
      produkt
  );
  const loader = useDataLoader({
    url: DATA.zadostiFixniNaroky(),
    method: "post",
    lazy: !canBeLoaded,
    payload: {
      datumOd: datumOd?.getTime(),
      datumDo: datumDo?.getTime(),
      zakaznik,
      uzivatel,
      projekt,
      zdroj,
      produkt
    }
  });

  useDidUpdateEffect(() => {
    canBeLoaded && !loader.loading && loader.loaded && loader.load();
  }, [
    datumOd?.getTime(),
    datumDo?.getTime(),
    zakaznik,
    uzivatel,
    projekt,
    zdroj,
    produkt
  ]);

  return loader;
}
